import { render, staticRenderFns } from "./meaning.vue?vue&type=template&id=c97260f6&scoped=true"
import script from "./meaning.vue?vue&type=script&lang=js"
export * from "./meaning.vue?vue&type=script&lang=js"
import style0 from "./meaning.vue?vue&type=style&index=0&id=c97260f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97260f6",
  null
  
)

export default component.exports